import SpritesheetAsset from "../Components/SpritesheetAsset";

function CardBack() {
    return (
        <div className="card">
            <SpritesheetAsset name="card-back.png" />
        </div>
    );
}

export default CardBack;
